<template>
  <div id="margin-setting-detail">
    <h3 v-if="detailData.length > 0">
      {{
      _.filter([
      _.get(detailData[0], 'account_term.label'),
      _.get(detailData[0], 'associated_term.label'),
      _.get(detailData[0], 'summary_term.label'),
      ]).join(' > ')
      }}
    </h3>
    <p v-else style="height: 50px"></p>
    <vxe-table
      border
      ref="xTable"
      show-footer
      resizable
      highlight-hover-row
      size="mini"
      max-height="500px"
      :loading="loading"
      :footer-method="footerMethod"
      footer-cell-class-name="footerCellClass"
      :data="tableData">
      <vxe-table-column type="seq" width="50"></vxe-table-column>
      <vxe-table-column
        width="300"
        :title="$t('form.item')">
        <template v-slot="{ row }">
          <MaterialSourceModelDisplay v-if="row.model_type === 'material' && row.model"
                                      :manufacturerPart="row.model"></MaterialSourceModelDisplay>
          <ActivityLabelDisplay v-if="(row.model_type === 'fee' || row.model_type === 'labor') && row.model"
                                :activity="row.model.source_model"
          ></ActivityLabelDisplay>
        </template>
      </vxe-table-column>
      <vxe-table-column field="price"
                        sortable
                        sort-by="price"
                        :filters="[{label: '> 1', value: 1}, {label: '> 5', value: 5}]"
                        :filter-method="filterPriceMethod"
                        :filter-multiple="false"
                        :formatter="formatterNum"
                        min-width="100"
                        align="right"
                        :title="$t('form.cost')">
      </vxe-table-column>
      <vxe-table-column field="quantity"
                        min-width="80"
                        align="right"
                        :title="$t('form.qty')">
      </vxe-table-column>
      <vxe-table-column field="scrap_amount"
                        min-width="100"
                        align="right"
                        :formatter="formatterNum"
                        :title="$t('form.scrap_amount')">
      </vxe-table-column>
      <vxe-table-column field="price_amount"
                        sortable
                        sort-by="price_amount"
                        :formatter="formatterNum"
                        min-width="120"
                        align="right"
                        :title="$t('form.amount')">
      </vxe-table-column>
      <vxe-table-column field="vat_amount"
                        sortable
                        sort-by="vat_amount"
                        :formatter="formatterNum"
                        min-width="120"
                        align="right"
                        :title="$t('form.tax')">
      </vxe-table-column>
      <vxe-table-column min-width="120"
                        align="left"
                        :title="$t('form.note')">
        <template v-slot="{ row }">
          <span v-if="row.model.price_adjustment">{{ $t('cost.materials.priceInfoForm.reason.' + row.model.price_adjustment.reason) }} {{ row.model.price_adjustment.remark }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
import MaterialSourceModelDisplay from '@/view/cost/components/widgets/material-source-model-display-widget'
import ActivityLabelDisplay from '@/view/cost/components/widgets/activity-label-display-widget'
import { intlCurrencyNumber } from '@/libs/util'
import XEUtils from 'xe-utils'

export default {
  name: 'margin-setting-detail-form',
  props: {
    detailData: {
      type: Array,
      required: true
    },
    currency: {
      type: String,
      default: 'CNY'
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  components: {
    MaterialSourceModelDisplay,
    ActivityLabelDisplay
  },
  data () {
    return {}
  },
  computed: {
    tableData () {
      return this.detailData
    }
  },
  methods: {
    intlCurrencyNumber,
    footerMethod ({ columns, columnIndex, data }) {
      const footerData = [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return this.$t('form.summary')
          }
          if (['price_amount', 'vat_amount', 'scrap_amount'].includes(column.property)) {
            return this.intlCurrencyNumber(this.currency, XEUtils.sum(data, column.property), 2, 2)
          }
          return null
        })
      ]
      return footerData
    },
    formatterNum ({ cellValue }) {
      return cellValue ? this.intlCurrencyNumber(this.currency, cellValue, 5, 5) : null
    },
    filterPriceMethod ({ value, row, column }) {
      return row.price >= value
    }
  }
}
</script>

<style lang="less">
  #margin-setting-detail {
    .vxe-table.size--mini .vxe-body--column.col--ellipsis .vxe-cell {
      max-height: 60px;
    }
    .footerCellClass {
      background-color: #F8F8F8;
      font-weight: bold;
    }
  }
</style>
